import { useModalContext } from '@/context/ModalContext'
import goToLogin from '@/navigation/CSR/goToLogin'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { useCallback } from 'react'

interface UseGuessActionProps {
  router: AppRouterInstance
  forceToLogin: boolean
}

const useGuessAction = ({ router, forceToLogin }: UseGuessActionProps) => {
  const { disableGuestCart } = UseClientModelContext()
  const { isLogged } = UseLoggedContext()
  const { openModal } = useModalContext()

  const redirectTo = useCallback(() => {
    const shouldRedirectToLogin =
      (disableGuestCart && !isLogged) || forceToLogin
    if (shouldRedirectToLogin) {
      goToLogin(router)
    } else {
      openModal('LOCALIZER')
    }
  }, [disableGuestCart, isLogged, forceToLogin, router, openModal])

  return useCallback(() => {
    redirectTo()
  }, [redirectTo])
}
export default useGuessAction
